import { ResolveControl } from 'components/CommentV2/ResolveControl/ResolveControl'
import { Comment, CommentStatus } from 'types'
import { ControlGroupBox } from 'components/CollabItem/Item/ControlGroup/ControlGroupBox'
import { Item } from 'components/CollabItem/Item'
import { CommentOptionsMenu } from 'components/CommentV2/CommentItem/CommentOptionsMenu'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Button } from 'blaze-components/WriterTopBar/Button'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ArrowRotateLeft2, Check2, Trash4 } from 'blaze-ui/icons'
import { useCommentPermissions } from 'components/CommentV2/useCommentPermissions'

interface Props {
  comment: Comment
}

export const CommentControlGroup = observer(({ comment }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const rootStore = useRootStore()
  const { canDelete, canToggleResolved } = useCommentPermissions(comment)
  const resolved = comment.status === CommentStatus.Resolved

  if (isMobile)
    return (
      <ControlGroupBox>
        <Button
          onPress={() => rootStore.comments.delete(comment.id, { trackArticleUpdate: true })}
          isDisabled={!canDelete}
          icon={Trash4}
        />
        <Button
          onPress={() => rootStore.comments.toggleResolved(comment.id)}
          isDisabled={!canToggleResolved}
          icon={resolved ? ArrowRotateLeft2 : Check2}
        />
      </ControlGroupBox>
    )

  return (
    <ControlGroupBox>
      <Item.Control tooltipTitle="More options">
        <CommentOptionsMenu comment={comment} />
      </Item.Control>
      <ResolveControl comment={comment} />
    </ControlGroupBox>
  )
})
